const PRIORITY_ORDER = [
	'submitted_for_review',
	'revision_requested',
	'draft',
	'draft_only',
	'approved',
]

const RANK = Object.fromEntries(PRIORITY_ORDER.map((status, index) => [status, index]))

export const normalizeEssayStatusKey = value => {
	const key = String(value || '')
		.trim()
		.toLowerCase()
		.replace(/\s+/g, '_')
		.replace(/-/g, '_')
	if (!key) return null
	if (key === 'final') return 'approved'
	return RANK[key] != null ? key : null
}

export const essayStatusSortKey = value => {
	const key = normalizeEssayStatusKey(value)
	if (!key) return PRIORITY_ORDER.length
	return RANK[key]
}

export const sortEssaysByPriority = essays =>
	[...(essays || [])].sort(
		(a, b) => essayStatusSortKey(a?.status) - essayStatusSortKey(b?.status),
	)
